// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ColumnWidthOutlinedSvg from "@fishx/icons-svg/es/asn/ColumnWidthOutlined";
import FishxIcon from '../components/FishxIcon';

var ColumnWidthOutlined = function ColumnWidthOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ColumnWidthOutlinedSvg
  }));
};

ColumnWidthOutlined.displayName = 'ColumnWidthOutlined';
export default React.forwardRef(ColumnWidthOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ColumnWidthOutlined.js
// module id = 2285
// module chunks = 0